<div *transloco="let t; prefix: 'ai-assistant'">
  @for (m of messages(); track $index) {
    <div
      class="ai-assistant-drawer__message ai-assistant-drawer__message--{{ m.role }}"
      [attr.data-message-index]="$index"
    >
      @if (m.role !== 'assistant') {
        <div class="ai-assistant-drawer__message-bubble">
          @if (m.role === 'tool') {
            <xi-icon icon="check" color="success" iconSize="small"></xi-icon>
          }
          {{ m.text }}
        </div>
      }
      @if (m.role === 'assistant') {
        <div class="ai-assistant-drawer__assistant-message">
          @if (shouldShowMessageActions(m)) {
            <button
              type="button"
              class="ai-assistant-drawer__message-actions"
              [matMenuTriggerFor]="assistantMessageMenu"
              (click)="openMessageMenu(m, $event, $index)"
              [attr.aria-label]="t('message-actions')"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
          }
          <div class="ai-assistant-drawer__message-content">
            @if (m.chartData) {
              <div class="ai-assistant-drawer__chart-container">
                <button
                  type="button"
                  class="ai-assistant-drawer__chart-copy"
                  [matTooltip]="t('copy-chart-values')"
                  (click)="copyChartValuesToClipboard(m, $event)"
                  [attr.aria-label]="t('copy-chart-values')"
                >
                  <mat-icon>content_copy</mat-icon>
                </button>
                <div class="ai-assistant-drawer__chart-title">
                  {{ m.chartData.config.title }}
                </div>
                <app-ai-chart [chartData]="m.chartData"></app-ai-chart>
              </div>
            } @else if (m.chartStatus === 'loading') {
              <div class="ai-assistant-drawer__chart-placeholder">
                <div class="ai-assistant-drawer__chart-placeholder-title">
                  {{ t('loading-chart') }}
                </div>
                <div class="ai-assistant-drawer__chart-placeholder-body">
                  <span>{{ t(getLoadingStatusKey(m)) }}</span>
                  <div class="ai-assistant-drawer__loading-spinner"></div>
                </div>
              </div>
            } @else if (m.chartStatus === 'error') {
              <div
                class="ai-assistant-drawer__chart-placeholder ai-assistant-drawer__chart-placeholder--error"
              >
                <div class="ai-assistant-drawer__chart-placeholder-title">
                  {{ t('chart-unavailable') }}
                </div>
                <div class="ai-assistant-drawer__chart-placeholder-body">
                  {{ t('chart-unavailable-body') }}
                </div>
              </div>
            } @else if (m.toolContent) {
              @switch (m.toolContent.type) {
                @case ('table') {
                  <app-ai-table [tableData]="m.toolContent.data"></app-ai-table>
                }
                @case ('metrics') {
                  <app-ai-metrics [metrics]="m.toolContent.data"></app-ai-metrics>
                }
                @case ('documents') {
                  <app-ai-document-cards [data]="m.toolContent.data"></app-ai-document-cards>
                }
                @case ('smartSummary') {
                  <app-ai-smart-summary [data]="m.toolContent.data"></app-ai-smart-summary>
                }
                @case ('comparison') {
                  <app-ai-comparison [data]="m.toolContent.data"></app-ai-comparison>
                }
                @case ('suggestActions') {
                  <app-ai-suggest-actions
                    [data]="m.toolContent.data"
                    (actionClicked)="actionPromptRequested.emit($event.label)"
                  ></app-ai-suggest-actions>
                }
                @case ('drivers') {
                  <app-ai-drivers [data]="m.toolContent.data"></app-ai-drivers>
                }
              }
            } @else if (m.toolContentStatus === 'loading') {
              <div class="ai-assistant-drawer__chart-placeholder">
                <div class="ai-assistant-drawer__chart-placeholder-title">
                  {{ t('loading-content') }}
                </div>
                <div class="ai-assistant-drawer__chart-placeholder-body">
                  <span>{{ t(getLoadingStatusKey(m)) }}</span>
                  <div class="ai-assistant-drawer__loading-spinner"></div>
                </div>
              </div>
            } @else if (m.toolContentStatus === 'error') {
              <div
                class="ai-assistant-drawer__chart-placeholder ai-assistant-drawer__chart-placeholder--error"
              >
                <div class="ai-assistant-drawer__chart-placeholder-title">
                  {{ t('content-unavailable') }}
                </div>
                <div class="ai-assistant-drawer__chart-placeholder-body">
                  {{ t('content-unavailable-body') }}
                </div>
              </div>
            } @else {
              <div [innerHTML]="m.content"></div>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (isWaitingForResponse()) {
    <div class="ai-assistant-drawer__message ai-assistant-drawer__message--assistant">
      <div class="ai-assistant-drawer__message-bubble ai-assistant-drawer__message-bubble--typing">
        <p>{{ t('status-analyzing-data') }}</p>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  }

  <mat-menu #assistantMessageMenu="matMenu" (closed)="clearActiveMenuMessage()">
    <button mat-menu-item type="button" (click)="copyActiveMessageToClipboard()">
      {{ t('copy-to-clipboard') }}
    </button>
    <button mat-menu-item type="button" disabled>{{ t('publish-insight') }}</button>
  </mat-menu>
</div>
